import styled from 'styled-components';
import { Badge } from 'antd';

export const ExportHistoryWrapper = styled.div`
  background: #fff;
  border-radius: 5px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  margin-bottom: 24px;

  > .ant-spin {
    display: block;
    padding: 48px 0;
  }
`;

export const ExportHistoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e8ecf1;
`;

export const ExportHistoryTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #31394d;
`;

export const ExportHistoryTitleIcon = styled.span`
  margin-right: 8px;
  font-size: 16px;
  color: #556069;
`;

export const ExportHistoryItem = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e8ecf1;

  &:last-child {
    border-bottom: none;
  }

  .ant-collapse {
    .ant-collapse-header {
      padding: 4px 0 !important;
    }
    .ant-collapse-content-box {
      padding: 4px 0 8px 0 !important;
    }
  }
`;

export const ExportHistoryItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
`;

export const ExportHistoryItemTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #31394d;
`;

export const ExportHistoryItemStatus = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: ${({ $color }) => $color || '#556069'};
  border: 1px solid ${({ $color }) => $color || '#d9d9d9'};
  border-radius: 16px;
  padding: 2px 12px;
  white-space: nowrap;
`;

export const ExportHistoryItemMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #676f7e;
  line-height: 22px;
`;

export const EllipsisText = styled.span`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ExportHistoryItemActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

export const FiltersAppliedContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 4px;
`;

export const FilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
`;

export const FilterLabel = styled.span`
  color: #748aa1;
`;

export const FilterValue = styled.span`
  color: #1890ff;
`;

export const EmptyStateWrapper = styled.div`
  padding: 48px 0;
`;

export const ExportHistoryBadge = styled(Badge)`
  .ant-badge-count {
    background-color: #e8ecf1;
    color: #556069;
    margin-left: 8px;
    font-size: 12px;
    box-shadow: none;
  }
`;
